import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './Alert.cssmodule.less';
import { clickButton } from '../../actions/Modal';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';

class Textarea extends BaseComponent {
    constructor(props) {
        super(props);
        this.setAlertTheme(props.theme);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.state = {
            dontShowChecked: false,
        };
    }

    componentDidMount() {
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.keyboardEvent);
        document.addEventListener('touchmove', this.preventDefault, {
            passive: false,
        });
    }

    componentWillUnmount() {
        document.body.style.overflow = 'auto';
        document.removeEventListener('keydown', this.keyboardEvent);
        document.removeEventListener('touchmove', this.preventDefault, {
            passive: false,
        });
    }

    keyboardEvent = (e) => {
        const { keyCode } = e;
        e.preventDefault();
        if (e.repeat) {
            return;
        }
        if (keyCode === 13) {
            this.handleButtonClick('ok');
        } else if (keyCode === 27) {
            this.handleButtonClick('close');
        }
    };

    preventDefault(e) {
        e.preventDefault();
    }

    setAlertTheme(theme) {
        const themeStyle = this.getTheme(theme, 'ALERT');
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;

        const { item = {} } = this.props;
        const { options = {} } = item;
        const { withDontShowAgain = false } = options;
        const dontShowChecked = withDontShowAgain
            ? this.state.dontShowChecked
            : undefined;

        clickButton({
            event,
            data: {
                dontShowChecked,
            },
        });
    }

    createContent(content) {
        let view = null;
        try {
            if (typeof content === 'object') {
                view = (
                    <div
                        style={{
                            width: '100%',
                            height: '430px',
                            border: 'solid 1px #d8d8d8',
                            fontFamily: 'NanumBarunGothicOTF',
                            resize: 'none',
                            objectFit: 'contain',
                            fontSize: '14px',
                            fontWeight: 'normal',
                            fontStretch: 'normal',
                            fontStyle: 'normal',
                            lineHeight: 1.43,
                            letterSpacing: 'normal',
                            color: '#3b3b3b',
                            padding: '15px',
                            textAlign: 'left',
                            overflow:"scroll"
                        }}
                        dangerouslySetInnerHTML={{
                            __html: content.outerHTML,
                        }}
                    />
                );
            } else if (typeof content === 'string') {
                view = (
                    <textarea
                        style={{
                            width: '100%',
                            height: '430px',
                            border: 'solid 1px #d8d8d8',
                            fontFamily: 'NanumBarunGothicOTF',
                            resize: 'none',
                            objectFit: 'contain',
                            fontSize: '14px',
                            fontWeight: 'normal',
                            fontStretch: 'normal',
                            fontStyle: 'normal',
                            lineHeight: 1.43,
                            letterSpacing: 'normal',
                            color: '#3b3b3b',
                            padding: '15px',
                        }}
                        disabled
                        value={content}
                    ></textarea>
                );
            }
        } catch (e) {}
        return view;
    }

    handleDontShowChecked() {
        const { dontShowChecked } = this.state;
        this.setState({
            dontShowChecked: !dontShowChecked,
        });
    }

    render() {
        const { item = {} } = this.props;
        const { options = {} } = item;
        const {
            positiveButtonText = this.Utils.getLang('Buttons.course_done'),
            positiveButtonStyle = {},
            withDontShowAgain = false,
        } = options;
        const { dontShowChecked } = this.state;

        return (
            <div
                className={this.Style.alert}
                style={{ width: '485px', maxHeight: '636px' }}
            >
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                >
                    {this.props.item.title}
                </Title>
                <div className={this.Style.contentView}>
                    <div
                        className={this.Style.content}
                        style={{ width: '425px' }}
                    >
                        {this.createContent(this.props.item.content)}
                    </div>
                    <Button
                        className={this.Style.button}
                        text={positiveButtonText}
                        style={positiveButtonStyle}
                        onClick={() => this.handleButtonClick('ok')}
                    />
                    {withDontShowAgain && (
                        <div
                            className={this.Style.checkBox}
                            onClick={() => {
                                this.handleDontShowChecked();
                            }}
                        >
                            <div
                                className={`${
                                    this.Style.checkDiv
                                } ${dontShowChecked && this.Style.checked}`}
                                style={{
                                    width: 18,
                                    height: 18,
                                }}
                            />
                            <span className={this.Style.label}>
                                {this.Utils.getLang('General.dont_show_again')}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

Textarea.displayName = 'Alert';
Textarea.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(undefined, mapDispatchToProps)(Textarea);



// WEBPACK FOOTER //
// ./components/ModalSet/Textarea.js